const cache: Record<string, HTMLAudioElement> = {};

function getAudio(src: string): HTMLAudioElement {
  if (!cache[src]) {
    cache[src] = new Audio(src);
  }
  return cache[src];
}

function play(src: string): void {
  const audio = getAudio(src);
  audio.currentTime = 0;
  audio.play().catch(() => {
    // Ignore errors (e.g. autoplay policy before first user gesture)
  });
}

export const voiceSounds = {
  ready: () => play("/sounds/voice-ready.wav"),
  done: () => play("/sounds/voice-done.wav"),
  cancel: () => play("/sounds/voice-cancel.wav"),
};
